export default class User {
    constructor(userName, password){
        this.userName = userName;
        this.password = password;
    }
}